import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/assets/css/basic.css';
import './icons/svgIcon.js'; //vue中使用svg
import SvgIcon from './components/svgIcon/index.vue'; //vue中使用svg
Vue.component('svg-icon', SvgIcon); //vue中使用svg

import '@/assets/font/PingFang-SC/font.css';
import '@/assets/font/DIN/font.css';
import '@/assets/font/inter-variablefont/font.css';
import '@/assets/font/Inter/font.css';
import mqttTool from '@/utils/mqttTool';
import otaMqttTool from '@/utils/otaMqttTool';
import { i18n } from './i18n/i18n';

import './utils/permission.js';
import px2remMixin from './mixins/px2remMixin.js';
import px2remDirectives from './directives/px2rem.js';
import { px2rem, getCurrentPx, getScaleRatio } from './utils/px2rem.js';

import {
  Button,
  Progress,
  Loading,
  Dialog,
  Form,
  FormItem,
  Input,
  Message,
  Carousel,
  CarouselItem,
  Select,
  Option,
  DatePicker,
  Checkbox,
  CheckboxGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Empty,
  TimeSelect,
  TimePicker,
  Notification,
  Image,
  Slider
} from 'element-ui';

Vue.use(Button);
Vue.use(Progress);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Slider);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Empty);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Image);
Vue.use(Loading.directive);

Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;

Vue.config.productionTip = false;

Vue.prototype.$mqttTool = mqttTool;
Vue.prototype.$otaMqttTool = otaMqttTool;

// 注册px2rem相关方法
Vue.prototype.px2rem = px2rem;
Vue.prototype.getCurrentPx = getCurrentPx;
Vue.prototype.getScaleRatio = getScaleRatio;

// 注册全局混入
Vue.mixin(px2remMixin);

// 注册指令
Vue.directive('px2rem', px2remDirectives.px2rem);
Vue.directive('responsive', px2remDirectives.responsive);

new Vue({
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
